import React, { useCallback } from "react"
import { useTranslation } from "react-i18next"
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog"
import { ProductTranslations, ProductTranslationsData } from "./ProductTranslations"
import { Button } from "@strapi/design-system"

interface ProductTranslationsModalProps {
  isOpen: boolean
  onClose: () => void
  productId: string
  merchantId: string
  skuIds: string[]
  defaultProductName: string
  defaultSkuNames: Record<string, string>
  defaultSkuNumbers?: Record<string, string>
  translations: ProductTranslationsData
  onChange: (translations: ProductTranslationsData) => void
  onSaveSuccess?: () => void
  savedLanguages?: string[]
}

export const ProductTranslationsModal: React.FC<ProductTranslationsModalProps> = ({
  isOpen,
  onClose,
  productId,
  merchantId,
  skuIds,
  defaultProductName,
  defaultSkuNames,
  defaultSkuNumbers,
  translations,
  onChange,
  onSaveSuccess,
  savedLanguages = [],
}) => {
  const { t } = useTranslation()

  const handleDone = useCallback(() => {
    // Just close the modal - translations are already saved to React state via onChange
    onClose()
  }, [onClose])

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent
        className="!max-w-4xl max-h-[90vh] overflow-y-auto flex flex-col"
        style={{ backgroundColor: "#1f2937" }}
      >
        <DialogHeader>
          <DialogTitle style={{ color: "white" }}>{t("productPage.translations")}</DialogTitle>
        </DialogHeader>
        <div className="px-4 flex-1 overflow-y-auto">
          <ProductTranslations
            productId={productId}
            skuIds={skuIds}
            defaultProductName={defaultProductName}
            defaultSkuNames={defaultSkuNames}
            defaultSkuNumbers={defaultSkuNumbers}
            translations={translations}
            onChange={onChange}
            savedLanguages={savedLanguages}
          />
        </div>
        <DialogFooter className="mt-6 gap-3">
          <Button variant="default" onClick={handleDone}>
            {t("done")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

